import { useEffect, useState } from "react";
import { SeoDraftSubscriptionType } from "./seoDraftStore";

/** Re-renders the caller whenever the draft changes; the installed React typings lack useSyncExternalStore. */
export function useSeoDraftVersion(draft: SeoDraftSubscriptionType): number {
  const [version, setVersion] = useState(draft.getVersion());
  useEffect(() => {
    setVersion(draft.getVersion());
    return draft.subscribe(() => setVersion(draft.getVersion()));
  }, [draft]);
  return version;
}
